import React from 'react'

export function FigureQuestionAnswerForm({ q, answer, onChange }) {
  const payload = q?.payload || {}
  const figureUrl = typeof payload.figure_url === 'string' ? payload.figure_url : ''
  const caption = typeof payload.caption === 'string' ? payload.caption : ''
  const answerLinesRaw = payload.answer_lines != null ? Number(payload.answer_lines) : 6
  const answerLines = Number.isFinite(answerLinesRaw) && answerLinesRaw > 0 ? answerLinesRaw : 6

  const value = typeof answer?.value === 'string' ? answer.value : ''

  const minHeight = Math.max(80, answerLines * 20)

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {figureUrl && (
        <div style={{ textAlign: 'center' }}>
          <img
            src={figureUrl}
            alt={caption || 'سؤال على شكل رسم/خريطة'}
            style={{ maxWidth: '100%', borderRadius: 8, border: '1px solid #e5e7eb' }}
          />
        </div>
      )}
      {caption && (
        <div style={{ fontSize: 13, color: '#4b5563', textAlign: 'center', whiteSpace: 'pre-wrap' }}>
          {caption}
        </div>
      )}
      <textarea
        value={value}
        onChange={e => onChange(q, { value: e.target.value })}
        style={{
          padding: '8px 10px',
          borderRadius: 8,
          border: '1px solid #e5e7eb',
          minHeight,
          resize: 'vertical',
        }}
        placeholder="اكتب إجابتك هنا..."
      />
    </div>
  )
}
